var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGithub(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 21C16 21 16 18.73 16 18C16 17.37 16.15 16.04 15.5 15.5C16.89 15.37 17.98 14.92 19 14C20.02 13.08 20.5 11.69 20.5 9.5C20.5 8 20.25 7 19.5 6C19.79 5.22 19.84 4 19.5 3C17.94 3 16.53 4.07 16 4.5C15.61 4.4 14.67 4 13 4C11.33 4 10.39 4.4 10 4.5C9.47 4.07 8.06 3 6.5 3C6.16 4 6.21 5.22 6.5 6C5.75 7 5.5 8 5.5 9.5C5.5 11.69 5.98 13.08 7 14C8.02 14.92 9.11 15.37 10.5 15.5C9.85 16.04 10 17.37 10 18C10 18.73 10 21 10 21",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10 19C8.59 19 7.16 18.44 6.31 17.81C5.47 17.18 5.22 16.15 4 15.5",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGithub);
export default __webpack_public_path__ + "static/media/github.22cadba48bf935c66b5bbb0a0d1491c5.svg";
export { ForwardRef as ReactComponent };